import queryString from 'query-string';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import AcceptInvitationForm from './AcceptInvitationForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import LoginForm from './LoginForm';
import ResetPasswordForm from './ResetPasswordForm';
import VerifyEmailForm from './VerifyEmailForm';

type AuthMode = 'login' | 'forgot-password' | 'reset-password' | 'verify-email' | 'accept-invitation';

const AuthPage: React.FC = () => {
  const location = useLocation();
  const query = queryString.parse(location.search);

  // Determine initial mode based on URL
  const getInitialMode = (): AuthMode => {
    if (query.token && location.pathname.includes('accept-invitation')) {
      return 'accept-invitation';
    }
    if (query.token && location.pathname.includes('reset-password')) {
      return 'reset-password';
    }
    if (query.token && location.pathname.includes('verify-email')) {
      return 'verify-email';
    }
    if (location.pathname.includes('forgot-password')) {
      return 'forgot-password';
    }
    // Redirect signup attempts to login
    if (location.pathname.includes('signup')) {
      return 'login';
    }
    return 'login';
  };

  const [mode, setMode] = useState<AuthMode>(getInitialMode());

  const renderAuthForm = () => {
    switch (mode) {
      case 'login':
        return (
          <LoginForm
            onSwitchToForgotPassword={() => setMode('forgot-password')}
          />
        );
      case 'forgot-password':
        return (
          <ForgotPasswordForm
            onSwitchToLogin={() => setMode('login')}
          />
        );
      case 'reset-password':
        return (
          <ResetPasswordForm
            token={query.token as string}
            onSwitchToLogin={() => setMode('login')}
          />
        );
      case 'verify-email':
        return (
          <VerifyEmailForm
            token={query.token as string}
            onSwitchToLogin={() => setMode('login')}
          />
        );
      case 'accept-invitation':
        return (
          <AcceptInvitationForm
            token={query.token as string}
            onSwitchToLogin={() => setMode('login')}
          />
        );
      default:
        return (
          <LoginForm
            onSwitchToForgotPassword={() => setMode('forgot-password')}
          />
        );
    }
  };

  return <>{renderAuthForm()}</>;
};

export default AuthPage;